// FormScreen.tsx

'use client';

import { WVFormScreen } from "@ninjacart/nc-nk-app";

export default () => {
    return <WVFormScreen />;
};

